import { ContentSection, Heading } from '@cinch-labs/design-system'
import { StoryblokTable } from '@cinch-nx/data-storyblok'
import renderWithResolver from '@cinch-nx/landing-ui-shared/lib/rich-text-renderer/rich-text-renderer'
import { Table } from '@cinch-nx/landing-ui-shared/lib/shared/table'
import { StoryblokRenderer } from '@cinch-nx/landing-ui-shared/lib/storyblok-renderer/storyblok-renderer'

import Wrapper from '@cinch-nx/shared-ui/lib/wrapper/wrapper'

import { storyblokComponents } from './data/storyblok-renderer-map'
import styles from './landing-feature-policy-pages.module.css'
import { PolicyPageStoryContent } from './types/policy-page'

export interface PolicyPageFeatureProps {
  content: PolicyPageStoryContent
}

const shouldRenderTable = (table: StoryblokTable): boolean =>
  table?.fieldtype === 'table' &&
  table?.tbody.length > 0 &&
  table.tbody?.[0].body?.[0]?.value !== ' '

const PolicyPageFeature: React.FC<PolicyPageFeatureProps> = ({ content }) => {
  const { title, body, table, clauses, cookiePolicy, widestRangeClaimTable } =
    content
  return (
    <Wrapper
      className={{ inner: styles.container }}
      data-testid="feature-policy-page-wrapper"
    >
      <Heading element="h1" className={styles.title} fontSize="h1">
        {title}
      </Heading>
      <ContentSection
        classNames={{
          body: 'storyblokRichTextBody',
        }}
      >
        {renderWithResolver(body, true)}
      </ContentSection>
      {table && shouldRenderTable(table) && <Table {...table} />}
      {widestRangeClaimTable &&
        shouldRenderTable(widestRangeClaimTable?.table) && (
          <Table {...widestRangeClaimTable?.table} />
        )}
      {clauses && (
        <StoryblokRenderer block={clauses} components={storyblokComponents} />
      )}
      {cookiePolicy && (
        <StoryblokRenderer
          block={cookiePolicy}
          components={storyblokComponents}
        />
      )}
    </Wrapper>
  )
}

export default PolicyPageFeature
